import { useContext } from "react";
import { fixPrecisionAndFormat } from "@/utils/fixPrecisionAndFormat";
import { MapContext } from "../../context.jsx";
import {
  CartLargeMinimalistic,
  DangerCircle,
  Dollar,
  LayersMinimalistic,
  Trash,
} from "@/components/Icons";
import Button from "@/components/Common/Button";

const Sidebar = ({ isLoading, buyLandHandler }) => {
  const { tileNumber, emptySelectedCells, titleInfo } =
    useContext(MapContext);
  return (
    <div className={`hidden desktop:block`}>
      <div className="space-y-4 absolute desktop:absolute rounded-[20px] bg-blackshade-900 shadow-frame p-4 left-8 top-10 desktop:w-[380px] z-10">
        <div className="rounded-2xl bg-dashboard-frame p-3">
          <h2 className="text-label-lg desktop:text-subheading-md text-white">
            LAND INFO
          </h2>
        </div>
        <div className="rounded-2xl bg-dashboard-frame p-3 flex justify-between items-center">
          <div className="flex gap-2 items-center">
            <LayersMinimalistic className="text-gold-500 w-5 h-5" />
            <h2 className="text-label-lg text-blackshade-200">
              Selected TILES
            </h2>
          </div>
          <div className="text-white desktop:text-label-lg">
            <span className="text-gold-500">{tileNumber}</span> TILES
          </div>
        </div>
        <div className="rounded-2xl bg-dashboard-frame p-3">
          <div className="flex justify-between items-center mb-3">
            <div className="flex gap-2 items-center">
              <Dollar className="text-gold-500 w-5 h-5" />
              <h2 className="text-label-lg text-blackshade-200">Value</h2>
            </div>
            <div className="text-white text-label-lg">
              $ {fixPrecisionAndFormat(tileNumber * titleInfo.tilePrice, 2)}
            </div>
          </div>
          <div className="flex justify-between items-center text-label-md mb-2">
            <h2 className="text-blackshade-200">PME Price Usd</h2>
            <div className="text-blackshade-200">{titleInfo.pmePrice}</div>
          </div>
          <div className="flex justify-between items-center text-label-md mb-2">
            <h2 className="text-blackshade-200">Current Value Per Tile</h2>
            <div className="text-blackshade-200">$ {titleInfo.tilePrice}</div>
          </div>
          <div className="flex justify-between items-center text-label-md">
            <h2 className="text-blackshade-200">Growth Since Creation</h2>
            <div className="text-blackshade-200">{titleInfo.tileGrowth}%</div>
          </div>
        </div>

        <div className="flex items-center gap-3 text-white">
          <DangerCircle className="w-4 h-4" />
          <div className="text-body-md">
            <span className="text-label-sm">A minimum of</span> 10 tiles must be
            selected.
          </div>
        </div>
        <div className="flex items-center gap-3 text-white mt-2">
          <DangerCircle className="w-4 h-4" />
          <div className="text-body-md">
            <span className="text-label-sm">A maximum of</span> 100,000 tiles
            must be selected.
          </div>
        </div>
        <div className="border-t border-blackshade-800 pt-3 mt-4 flex flex-row-reverse desktop:block">
          <Button
            model="main"
            size="md"
            className="w-full"
            onClick={buyLandHandler}
            isLoading={isLoading}
          >
            <CartLargeMinimalistic />
            <span>Buy Now</span>
          </Button>
          <Button
            model="error"
            size="md"
            className="desktop:mt-4 w-full flex items-center"
            onClick={() => emptySelectedCells()}
          >
            <Trash />
            <span>Clear Selecttion</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
